import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/style.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import Countdown from "react-countdown";
import {
	banner_img,
	Category1,
	Category2,
	Category3,
	Category4,
	Category5,
	Category6,
	Category7,
	Category8,
	pro1,
	pro2,
	pro3,
	pro4,
	seller1,
	seller2,
	seller3,
	seller4,
	seller5,
	seller6,
} from "../../constants";

const Home = () => {
	$(document).ready(function () {
		$(
			'.product-card-wrapper .product-content-wrapper .counter-total-wrapper input[type="number"]',
		).change(function () {
			if (this.val() < 0) {
				console.log(this.val());
			}
		});
	});
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
	};
	const saverssettings = {
		dots: false,
		arrow: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
	};
	const seller_category = {
		dots: false,
		arrow: true,
		infinite: true,
		speed: 500,
		slidesToShow: 5,
		slidesToScroll: 1,
	};
	const catesettings = {
		dots: false,
		arrow: true,
		infinite: true,
		speed: 500,
		slidesToShow: 6,
		slidesToScroll: 2,
	};
	//   Browse category data starts here
	const Category = [
		{
			id: 1,
			Category_img: Category1,
			Category_name: "Bath Milks",
		},
		{
			id: 2,
			Category_img: Category2,
			Category_name: "Breads & Sweets",
		},
		{
			id: 3,
			Category_img: Category3,
			Category_name: "Clothing",
		},
		{
			id: 4,
			Category_img: Category4,
			Category_name: "Health care",
		},
		{
			id: 5,
			Category_img: Category5,
			Category_name: "Beauty product",
		},
		{
			id: 6,
			Category_img: Category6,
			Category_name: "Skin Care",
		},
		{
			id: 7,
			Category_img: Category7,
			Category_name: "Pet Foods",
		},
		{
			id: 8,
			Category_img: Category8,
			Category_name: "Others",
		},
	];
	//   Browse category data ends here
	return (
		<>
			<Header />
			{/* banner starts here */}
			<section className="banner">
				<div className="container-fluid px-0">
					<div className="row">
						<div className="col-lg-12">
							<div className="banner-slides-wrapper">
								<Slider {...settings}>
									<div
										className="single-banner-slide-wrapper"
										style={{ background: `url(${banner_img})` }}
									>
										<div className="container">
											<div className="row">
												<div className="col-lg-2"></div>
												<div className="col-lg-10">
													<div className="banner-content-wrapper">
														<h5>BE PART OF THE CHANGE</h5>
														<h1>THE SUSTAINABLE MARKETPLACE</h1>
														<p>
															New arrivals with naturre fruits, juice milks,
															essential for summer
														</p>
														<a href="#" className="btn">
															Shop Now
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										className="single-banner-slide-wrapper"
										style={{ background: `url(${banner_img})` }}
									>
										<div className="container">
											<div className="banner-content-wrapper">
												<h5>BE PART OF THE CHANGE</h5>
												<h1>THE SUSTAINABLE MARKETPLACE</h1>
												<p>
													New arrivals with naturre fruits, juice milks,
													essential for summer
												</p>
												<a href="#" className="btn">
													Shop Now
												</a>
											</div>
										</div>
									</div>
									<div
										className="single-banner-slide-wrapper"
										style={{ background: `url(${banner_img})` }}
									>
										<div className="container">
											<div className="banner-content-wrapper">
												<h5>BE PART OF THE CHANGE</h5>
												<h1>THE SUSTAINABLE MARKETPLACE</h1>
												<p>
													New arrivals with naturre fruits, juice milks,
													essential for summer
												</p>
												<a href="#" className="btn">
													Shop Now
												</a>
											</div>
										</div>
									</div>
								</Slider>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* banner ends here */}
			{/* Browse category starts here */}
			<section className="brwose-category">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="heading-wrapper">
								<h3>Browse by Category</h3>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<div className="category-slides-wrapper">
								<Slider {...catesettings}>
									{Category.map((data, index) => {
										return (
											<>
												<div key={index} className="single-slide-wrapper">
													<div className="slider-img-wrapper">
														<figure>
															<img
																src={data?.Category_img}
																alt=""
																className="img-fluid"
															/>
														</figure>
													</div>
													<div className="slide-content-wrapper">
														<h5>{data?.Category_name}</h5>
													</div>
												</div>
											</>
										);
									})}
								</Slider>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Browse category ends here */}
			{/* top savers starts here */}
			<section className="top-savers">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="saver-heading-wrapper">
								<h2>Top Saver Today</h2>
								<span className="btn">
									{" "}
									<ruby>Expires in:</ruby>{" "}
									<span className="timer">
										<Countdown date={Date.now() + 100000000} />
									</span>
								</span>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<div className="row">
								<Slider {...saverssettings}>
									<div className="col-lg-4">
										<div className="product-card-wrapper">
											<div className="product-img-wrapper">
												<figure>
													<img src={pro1} className="img-fluid" alt="" />
												</figure>
											</div>
											<div className="product-content-wrapper">
												<h5>Brand Name</h5>
												<span className="ice">
													Ice Beck’s Beer 350ml x 24 Pieces
												</span>
												<div className="rating-wrapper">
													<ul>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li className="total-rating">
															<span>(12)</span>
														</li>
													</ul>
												</div>
												<h6>24 pieces / box</h6>
												<h4>$49.50</h4>
												<div className="progress-wrapper">
													<div className="progress"></div>
												</div>
												<div className="sold">
													<h6>Sold: 30/40</h6>
												</div>
												<div className="counter-total-wrapper">
													<input defaultValue="2" type="number" min="0" />
													<h6>
														Total: <span>$99.0</span>
													</h6>
												</div>
												<a href="#" className="btn">
													Add To Cart
												</a>
											</div>
										</div>
									</div>
									<div className="col-lg-4">
										<div className="product-card-wrapper">
											<div className="product-img-wrapper">
												<figure>
													<img src={pro2} className="img-fluid" alt="" />
												</figure>
												<div className="save-wrapper">
													<h6>Save 12%</h6>
												</div>
											</div>
											<div className="product-content-wrapper">
												<h5>Meat Brand</h5>
												<span className="ice">
													British Beef Mince (10% Fat)
												</span>
												<div className="rating-wrapper">
													<ul>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li className="total-rating">
															<span>(6)</span>
														</li>
													</ul>
												</div>
												<h6>450g</h6>
												<h4>
													<span style={{ color: "#FA532C" }}>$59.50 </span>
													<strike
														style={{ color: "#666666", FontSize: "12px" }}
													>
														{" "}
														$69.70
													</strike>
												</h4>
												<div className="progress-wrapper">
													<div className="progress"></div>
												</div>
												<div className="sold">
													<h6>Sold: 25/100</h6>
												</div>
												<div className="counter-total-wrapper">
													<input defaultValue="2" type="number" min="0" />
													<h6>
														Total: <span>$99.0</span>
													</h6>
												</div>
												<a href="#" className="btn">
													Add To Cart
												</a>
											</div>
										</div>
									</div>
									<div className="col-lg-4">
										<div className="product-card-wrapper">
											<div className="product-img-wrapper">
												<figure>
													<img src={pro3} className="img-fluid" alt="" />
												</figure>
											</div>
											<div className="product-content-wrapper">
												<h5>Farmart</h5>
												<span className="ice">Famart Farmhouse Soft White</span>
												<div className="rating-wrapper">
													<ul>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li className="total-rating">
															<span>(1)</span>
														</li>
													</ul>
												</div>
												<h6>800g</h6>
												<h4>$12.7</h4>
												<div className="progress-wrapper">
													<div className="progress"></div>
												</div>
												<div className="sold">
													<h6>Sold: 9/20</h6>
												</div>
												<div className="counter-total-wrapper">
													<input defaultValue="2" type="number" min="0" />
													<h6>
														Total: <span>$99.0</span>
													</h6>
												</div>
												<a href="#" className="btn">
													Add To Cart
												</a>
											</div>
										</div>
									</div>
									<div className="col-lg-4">
										<div className="product-card-wrapper">
											<div className="product-img-wrapper">
												<figure>
													<img src={pro4} className="img-fluid" alt="" />
												</figure>
											</div>
											<div className="product-content-wrapper">
												<h5>Brand Name</h5>
												<span className="ice">
													Ice Beck’s Beer 350ml x 24 Pieces
												</span>
												<div className="rating-wrapper">
													<ul>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li>
															<i className="fa fa-star"></i>
														</li>
														<li className="total-rating">
															<span>(4)</span>
														</li>
													</ul>
												</div>
												<h6>24 pieces / box</h6>
												<h4>$12.35</h4>
												<div className="progress-wrapper">
													<div
														className="progress"
														style={{ width: "75%" }}
													></div>
												</div>
												<div className="sold">
													<h6>Sold: 62/100</h6>
												</div>
												<div className="counter-total-wrapper">
													<input defaultValue="2" type="number" min="0" />
													<h6>
														Total: <span>$99.0</span>
													</h6>
												</div>
												<a href="#" className="btn">
													Add To Cart
												</a>
											</div>
										</div>
									</div>
								</Slider>
							</div>
						</div>
						{/* <div className="col-lg-3">
							<div className="off-wrapper">
								<div className="heading-wrapper">
									<h3>15% OFF</h3>
									<h5>
										For new member sign <br /> up at the first time
									</h5>
								</div>
								<div className="off-form-wrapper">
									<form action="">
										<div className="form-group">
											<input
												type="email"
												placeholder="email"
												className="form-control"
											/>
										</div>
										<div className="form-group">
											<input
												type="Password"
												placeholder="Password"
												className="form-control"
											/>
										</div>
										<div className="form-group">
											<input
												type="Password"
												placeholder="Re-type Password"
												className="form-control"
											/>
										</div>
										<div className="form-group">
											<button className="btn" type="submit">
												Register Now
											</button>
										</div>
									</form>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</section>
			{/* top savers ends here */}
			{/* Best Seller starts here */}
			<section className="best-seller">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="best-heading-wrapper">
								<h2>Best Seller</h2>
								<div className="tab-wrapper">
									<ul className="nav nav-tabs" id="myTab" role="tablist">
										<li className="nav-item" role="presentation">
											<button
												className="nav-link active"
												id="home-tab"
												data-bs-toggle="tab"
												data-bs-target="#home"
												type="button"
												role="tab"
												aria-controls="home"
												aria-selected="true"
											>
												All
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="profile-tab"
												data-bs-toggle="tab"
												data-bs-target="#profile"
												type="button"
												role="tab"
												aria-controls="profile"
												aria-selected="false"
											>
												Fruits & Vegetables
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="contact-tab"
												data-bs-toggle="tab"
												data-bs-target="#contact"
												type="button"
												role="tab"
												aria-controls="contact"
												aria-selected="false"
											>
												Frozen Seafoods
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Raw-tab"
												data-bs-toggle="tab"
												data-bs-target="#Raw"
												type="button"
												role="tab"
												aria-controls="Raw"
												aria-selected="false"
											>
												Raw Meats
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Coffes-tab"
												data-bs-toggle="tab"
												data-bs-target="#Coffes"
												type="button"
												role="tab"
												aria-controls="Coffes"
												aria-selected="false"
											>
												Coffes & Teas
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Pet-tab"
												data-bs-toggle="tab"
												data-bs-target="#Pet"
												type="button"
												role="tab"
												aria-controls="Pet"
												aria-selected="false"
											>
												Pet Foods
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Milks-tab"
												data-bs-toggle="tab"
												data-bs-target="#Milks"
												type="button"
												role="tab"
												aria-controls="Milks"
												aria-selected="false"
											>
												Milks & Dairies
											</button>
										</li>
									</ul>
								</div>
							</div>
							<div className="tab-content pt-5" id="myTabContent">
								<div
									className="tab-pane fade show active"
									id="home"
									role="tabpanel"
									aria-labelledby="home-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="profile"
									role="tabpanel"
									aria-labelledby="profile-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="contact"
									role="tabpanel"
									aria-labelledby="contact-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Raw"
									role="tabpanel"
									aria-labelledby="Raw-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Coffes"
									role="tabpanel"
									aria-labelledby="Coffes-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Pet"
									role="tabpanel"
									aria-labelledby="Pet-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Milks"
									role="tabpanel"
									aria-labelledby="Milks-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Best Seller ends here */}
			{/* Best Seller starts here */}
			<section className="best-seller">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="best-heading-wrapper">
								<h2>New Arrival</h2>
								<div className="tab-wrapper">
									<ul className="nav nav-tabs" id="myTab" role="tablist">
										<li className="nav-item" role="presentation">
											<button
												className="nav-link active"
												id="home-tab"
												data-bs-toggle="tab"
												data-bs-target="#home"
												type="button"
												role="tab"
												aria-controls="home"
												aria-selected="true"
											>
												All
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="profile-tab"
												data-bs-toggle="tab"
												data-bs-target="#profile"
												type="button"
												role="tab"
												aria-controls="profile"
												aria-selected="false"
											>
												Fruits & Vegetables
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="contact-tab"
												data-bs-toggle="tab"
												data-bs-target="#contact"
												type="button"
												role="tab"
												aria-controls="contact"
												aria-selected="false"
											>
												Frozen Seafoods
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Raw-tab"
												data-bs-toggle="tab"
												data-bs-target="#Raw"
												type="button"
												role="tab"
												aria-controls="Raw"
												aria-selected="false"
											>
												Raw Meats
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Coffes-tab"
												data-bs-toggle="tab"
												data-bs-target="#Coffes"
												type="button"
												role="tab"
												aria-controls="Coffes"
												aria-selected="false"
											>
												Coffes & Teas
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Pet-tab"
												data-bs-toggle="tab"
												data-bs-target="#Pet"
												type="button"
												role="tab"
												aria-controls="Pet"
												aria-selected="false"
											>
												Pet Foods
											</button>
										</li>
										<li className="nav-item" role="presentation">
											<button
												className="nav-link"
												id="Milks-tab"
												data-bs-toggle="tab"
												data-bs-target="#Milks"
												type="button"
												role="tab"
												aria-controls="Milks"
												aria-selected="false"
											>
												Milks & Dairies
											</button>
										</li>
									</ul>
								</div>
							</div>
							<div className="tab-content pt-5" id="myTabContent">
								<div
									className="tab-pane fade show active"
									id="home"
									role="tabpanel"
									aria-labelledby="home-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="profile"
									role="tabpanel"
									aria-labelledby="profile-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="contact"
									role="tabpanel"
									aria-labelledby="contact-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Raw"
									role="tabpanel"
									aria-labelledby="Raw-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Coffes"
									role="tabpanel"
									aria-labelledby="Coffes-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Pet"
									role="tabpanel"
									aria-labelledby="Pet-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
								<div
									className="tab-pane fade"
									id="Milks"
									role="tabpanel"
									aria-labelledby="Milks-tab"
								>
									<div className="row">
										<Slider {...seller_category}>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller1} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Asia Green Bananas</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>$19.25</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller2} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															British Beef Mine (Typically 10% Fat)
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(6)</span>
																</li>
															</ul>
														</div>
														<h6>454g</h6>
														<h4>$96.90</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller3} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 12%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>MartFury</h5>
														<span className="ice">US Yellow Water Melon</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(2)</span>
																</li>
															</ul>
														</div>
														<h6>5kg</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$59.50 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$69.70
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller4} className="img-fluid" alt="" />
														</figure>
														<div className="save-wrapper">
															<h6>Save 34%</h6>
														</div>
													</div>
													<div className="product-content-wrapper">
														<h5>Farmart</h5>
														<span className="ice">
															Spicies Snacks 6 Ready Salted
														</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(0)</span>
																</li>
															</ul>
														</div>
														<h6>100g</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>
														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller5} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Oatmeal Cookies</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(9)</span>
																</li>
															</ul>
														</div>
														<h6>5.8g suger/serving</h6>
														<h4>$25.6</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
											<div className="col-lg-3 px-0">
												<div className="product-card-wrapper">
													<div className="product-img-wrapper">
														<figure>
															<img src={seller6} className="img-fluid" alt="" />
														</figure>
													</div>
													<div className="product-content-wrapper">
														<h5>Brand Name</h5>
														<span className="ice">Canned Rices With Tofus</span>
														<div className="rating-wrapper">
															<ul>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li>
																	<i className="fa fa-star"></i>
																</li>
																<li className="total-rating">
																	<span>(1)</span>
																</li>
															</ul>
														</div>
														<h6>1 box</h6>
														<h4>
															<span style={{ color: "#FA532C" }}>$2.5 </span>
															<strike
																style={{ color: "#666666", FontSize: "12px" }}
															>
																{" "}
																$7.5
															</strike>
														</h4>

														<div className="counter-total-wrapper">
															<input type="number" min={0} />
															<h6>
																Total: <span>$38.5</span>
															</h6>
														</div>
														<a href="#" className="btn">
															Add To Cart
														</a>
													</div>
												</div>
											</div>
										</Slider>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Best Seller ends here */}
			<Footer />
		</>
	);
};

export default Home;
